import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Skeleton } from "antd";
import HotList from "../components/HotList";
import GamePay from "../components/GamePay";
import useControl from "../hooks/useControl";
import { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "./styles/scss/Goods.scss";
import {
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	Request,
	catchErrorHandle,
	checkLogin,
	sysMsg,
	countdown,
} from "../common";
import cid3 from "./styles/scss/img/goods/cid-3.png";
import cid4 from "./styles/scss/img/goods/cid-4.png";
import cid6 from "./styles/scss/img/goods/cid-6.png";
import Big from "big.js";

const cidObj = {
	3: cid3,
	4: cid4,
	6: cid6,
};

export default function App() {
	const location = useLocation();
	const isWjyz = location.state?.from === "wjyz";

	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);

	const [details, setDetails] = useState({});
	const [bannerList, setBannerList] = useState([]);
	const [typeNav, setTypeNav] = useState(0);
	const [typeList, setTypeList] = useState([]);
	const [platformNav, setPlatformNav] = useState(0);
	const [platformList, setPlatformList] = useState([]);
	const [recommendList, setRecommendList] = useState([]);
	const [gameIsShow, setGameIsShow] = useState(false);
	const [buyCount, setBuyCount] = useState(1);
	const { readyStart, stopGame, onProcessGame } = useControl();

	const memberTime = _state.userInfo?.totalMinutes;

	const isOnlineGame =
		onProcessGame?.playParam?.[1] === details.product_name &&
		onProcessGame?.isOnline;

	//查看某个商品详情才会返回is_super_vip_game，列表接口传入参数是筛选了大会员游戏的
	const canFreePlay =
		details.is_super_vip_game && countdown(details.created_at) <= 0;

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	useEffect(() => {
		let req = null;

		if (isWjyz) {
			req = new Request({
				url: "/open-platform/pro/productInfobyidWjyz",
				source: 1,
				data: {
					id: location.state?.id,
				},
			});

			const getData = async () => {
				try {
					const res = await req.send();

					if (res.code === 200 && res.data?.data) {
						const data = res.data.data[0];
						setDetails(data);

						setBannerList([
							{
								url: `https://cdn-wjyz.wanjiayizhan.com${encodeURI(
									data.img_url
								)}`,
							},
						]);

						setPlatformList([data.pro_platform]);

						setTypeList([data.pro_version]);
					}
				} catch (error) {
					console.log(catchErrorHandle(error));
				}
			};

			getData();
		} else {
			req = new Request({
				url: "/api/getProductDetail",
				data: {
					product_id: location.state?.product_id,
				},
			});

			const getData = async () => {
				try {
					const res = await req.send();

					if (res.status_code === 1000) {
						const data = res.data || {};
						setDetails(data);

						const imgArr = data.detail_img || [];
						let banner_img = imgArr.filter((ele) => ele.type === "img");
						banner_img = banner_img.slice(0, 5);
						setBannerList(banner_img);

						setPlatformList([data.platform_name]);

						setTypeList(["共享账号"]);
					}
				} catch (error) {
					console.log(catchErrorHandle(error));
				}
			};

			getData();
		}

		return () => {
			req.cancel();
		};
	}, [isWjyz, location.state?.id, location.state?.product_id]);

	useEffect(() => {
		const req = new Request({
			url: "/api/getProductList",
			data: {
				page: 1,
				pageSize: 5,
				service: "group",
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					setRecommendList(res.data.data);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [isWjyz]);

	const payId = (function () {
		if (isWjyz) {
			return details.id;
		} else {
			return details.product_id;
		}
	})();

	const payName = (function () {
		if (isWjyz) {
			return details.name;
		} else {
			return details.product_name;
		}
	})();

	const payDesc = (function () {
		if (isWjyz) {
			return "";
		} else {
			return details.product_key;
		}
	})();

	const payPrice = (function () {
		if (isWjyz) {
			return new Big(details.special_price ?? 0).div(100).toNumber();
		} else {
			return details.standard_price
				? typeNav === 0
					? details.standard_price.group?.price
					: details.standard_price.accoun?.price
				: 0;
		}
	})();

	const payImg = (function () {
		if (isWjyz) {
			return `https://cdn-wjyz.wanjiayizhan.com${encodeURI(details.img_url)}`;
		} else {
			return details.cover_img;
		}
	})();

	const buyGame = () => {
		checkLogin(_state, _dispatch, () => {
			setGameIsShow(true);
		});
	};

	const gamePayClose = () => {
		setGameIsShow(false);
	};

	const barPlayGame = () => {
		checkLogin(_state, _dispatch, async () => {
			if (isOnlineGame) {
				try {
					await stopGame();
				} catch (error) {
					sysMsg({
						msg: "停止游戏失败",
					});
				}
			} else {
				if (!_state.hasNetbarRight) {
					sysMsg({
						msg: "当前服务端不在线，请联系商家",
					});

					return;
				}

				readyStart({
					productId: details.product_id,
					isNetbarPlay: true,
				});
			}
		});
	};

	const memberPlayGame = async () => {
		if (memberTime > 0) {
			if (isOnlineGame) {
				try {
					await stopGame();
				} catch (error) {
					sysMsg({
						msg: "停止游戏失败",
					});
				}
			} else {
				readyStart({
					productId: details.product_id,
					isMemberPlay: true,
				});
			}
		} else {
			checkLogin(_state, _dispatch, () => {
				_dispatch(creator("setMemberPayIsShow", true));
			});
		}
	};

	return (
		<div className="main">
			<div className="goods">
				<div className="top">
					{details.name || details.product_name ? (
						<div className="left">
							<Swiper
								modules={[Pagination, Autoplay]}
								slidesPerView={1}
								autoplay={true}
								pagination={{
									el: ".pagination",
									type: "bullets",
									clickable: true,
									bulletClass: "btn",
									bulletActiveClass: "active",
									renderBullet: function (index, className) {
										return isWjyz
											? ""
											: `<div class="${className}" style="background: url(${bannerList[index]?.url}) center top no-repeat; background-size: 100% 100%;"></div>`;
									},
								}}
							>
								{bannerList.map((ele, index) => {
									return (
										<SwiperSlide
											key={index}
											style={{ backgroundImage: `url(${ele.url})` }}
										></SwiperSlide>
									);
								})}
							</Swiper>
							<div className="pagination"></div>
						</div>
					) : (
						<Skeleton.Image active style={{ width: 460, height: 278 }} />
					)}

					<Skeleton
						active
						paragraph={{ rows: 8 }}
						loading={!(details.name || details.product_name)}
						style={{ width: 680 }}
					>
						<div className="right">
							{isWjyz ? (
								<>
									<div>
										<span title={details.name}>{details.name}</span>
									</div>
									<div></div>
									<div>
										{details.sell_type === "账号" ? (
											<button type="button" className="active">
												<div>账号</div>
												<div>
													<span>￥</span>
													{details.special_price / 100}
												</div>
												<div>正品可换绑</div>
												<div>性价比之选</div>
											</button>
										) : (
											<button type="button" className="active">
												<div>CDK</div>
												<div>
													<span>￥</span>
													{details.special_price / 100}
												</div>
												<div>兑换至个人账号</div>
											</button>
										)}
									</div>
									<div>
										<span>平台类型</span>
										{platformList.map((ele, index) => {
											return (
												<button
													type="button"
													key={index}
													className={platformNav === index ? "active" : ""}
													onClick={() => {
														setPlatformNav(index);
													}}
												>
													{ele}
												</button>
											);
										})}
									</div>
									<div>
										<span>账号类型</span>
										{typeList.map((ele, index) => {
											return (
												<button
													type="button"
													key={index}
													className={typeNav === index ? "active" : ""}
													onClick={() => {
														setTypeNav(index);
													}}
												>
													{ele}
												</button>
											);
										})}
									</div>
									<div>
										<div className="buy-group">
											<div className="buy-count">
												<button
													type="button"
													onClick={() =>
														setBuyCount((prev) => (prev - 1 < 1 ? 1 : prev - 1))
													}
												>
													-
												</button>
												<input
													type="text"
													value={buyCount}
													onChange={(e) =>
														setBuyCount(
															e.target.value / 1 < 1 ? 1 : e.target.value / 1
														)
													}
												/>
												<button
													type="button"
													onClick={() => setBuyCount((prev) => prev + 1)}
												>
													+
												</button>
											</div>
											<button
												type="button"
												className="buy-game-btn"
												onClick={buyGame}
											>
												立即购买 ￥
												{new Big(details.special_price ?? 0)
													.div(100)
													.times(buyCount)
													.toNumber()}
											</button>
										</div>
										<div className="buy-tips">
											账号终生质保 | 官方采购正版游戏
										</div>
									</div>
								</>
							) : (
								<>
									<div>
										<span title={details.product_name}>
											{details.product_name}
										</span>
										{(details.tag || []).slice(0, 5).map((ele, index) => {
											return <div key={index}>{ele.name}</div>;
										})}
									</div>
									<div>{details.product_key}</div>
									<div>
										<button type="button" className="active">
											<div>共享版</div>
											<div>
												<span>￥</span>
												{payPrice}
											</div>
											<div>拥有账号使用权</div>
											{/* <div>大会员免费使用</div> */}
										</button>
										{/* <button type="button">
							<div>独享版</div>
							<div>
								<span>￥</span>145.9
							</div>
							<div>一人独享一号</div>
						</button> */}
									</div>
									<div>
										<span>平台类型</span>
										{platformList.map((ele, index) => {
											return (
												<button
													type="button"
													key={index}
													className={platformNav === index ? "active" : ""}
													onClick={() => {
														setPlatformNav(index);
													}}
												>
													{ele}
												</button>
											);
										})}
									</div>
									<div>
										<span>账号类型</span>
										{typeList.map((ele, index) => {
											return (
												<button
													type="button"
													key={index}
													className={typeNav === index ? "active" : ""}
													onClick={() => {
														setTypeNav(index);
													}}
												>
													{ele}
												</button>
											);
										})}
									</div>
									<div>
										<div className="buy-group">
											<button
												type="button"
												className="buy-game-btn"
												onClick={buyGame}
											>
												立即购买 ￥{payPrice}
											</button>
											{canFreePlay && (
												<button
													type="button"
													className="member-play-btn"
													onClick={memberPlayGame}
													style={{
														textIndent:
															memberTime > 0 ? (isOnlineGame ? 46 : 30) : 14,
													}}
												>
													{memberTime > 0
														? isOnlineGame
															? "停止游戏"
															: "大会员免费玩"
														: "开通大会员免费玩"}
												</button>
											)}
											{canFreePlay && isNetbar && (
												<button
													type="button"
													className="netbar-play-btn"
													onClick={barPlayGame}
												>
													<span></span>
													{isOnlineGame ? "停止游戏" : "本店免费玩"}
												</button>
											)}
										</div>
										<div
											className="buy-tips"
											style={isNetbar ? { display: "none" } : {}}
										>
											终身无条件退款 | 账号终生质保 | 支持游戏进度云存档
										</div>
									</div>
								</>
							)}
						</div>
					</Skeleton>
				</div>

				<div className="info">
					<Skeleton
						active
						paragraph={{ rows: 16 }}
						loading={!(details.name || details.product_name)}
					>
						{isWjyz ? (
							<>
								{[1872, 1888].includes(details.id) && (
									<div className="wjyz-introduce">
										<div className="title">
											<div className="left">商品介绍</div>
										</div>

										<div className="content">
											<div
												dangerouslySetInnerHTML={{
													__html:
														details.id === 1872
															? "此商品为包含随机游戏的游戏账号"
															: "此商品为包含随机游戏的游戏账号，购买该商品必定获得以下其中一款游戏：<br />1.GTA5豪华版——10%<br />2.城市：天际线——15%<br />3.泰坦陨落2——15%<br />4.求生之路2——15%<br />5.泰拉瑞亚——20%<br />6.方舟：生存进化——25%",
												}}
											/>
											<div></div>
										</div>
									</div>
								)}

								<div className="useage">
									<div className="title">
										<div className="left">激活方式</div>
									</div>

									<div className="content">
										<div>
											<img src={cidObj[details.cid]} alt="" />
										</div>
										<div></div>
									</div>
								</div>

								<div className="tips">
									<div className="title">
										<div className="left">购买须知</div>
									</div>

									<div className="content">
										<ul>
											{[1872].includes(details.id) ? (
												<>
													<li>
														1.本商品为steam账号，内含一个随机游戏。一旦售出，不支持任何形式的退换。
													</li>
													<li>
														2.购买后将提供steam账号、密码及原始邮箱信息，可支持玩家更改游戏密码、换绑邮箱及绑定手机令牌
													</li>
													<li>
														3.由于此商品为批量上传，如果连续购买多个可能出现重复游戏，批量购买时请谨慎。
													</li>
													<li>
														4.账号质保时间为3个月，3个月内账号出现非人为导致的问题可进行售后。
													</li>
													<li>
														5.所有购买本商品的用户视为阅读并同意以上条款。
													</li>
												</>
											) : [1861, 2033, 2034, 2035, 2036, 2038].includes(
													details.id
											  ) ? (
												<>
													<li>1.本商品为谷歌个人版账号。</li>
													<li>2.购买后将谷歌账号、密码及辅助邮箱。</li>
													<li>3.如果账号首次登录出现异常请及时联系客服。</li>
													<li>
														4.账号质保时间为7天，7天内账号出现非人为导致的问题可进行售后。
													</li>
													<li>
														5.所有购买本商品的用户视为阅读并同意以上条款。
													</li>
												</>
											) : (
												<>
													<li>
														1.商城内所有物品（账号、游戏CDK、充值卡）皆为网络虚拟物品。请在购买前仔细确认所购买的物品类型、价格、地区、版本等信息。由于该类物品的保密性和特殊性，因此物品一旦出售，不支持因电脑配置、服务器延迟、网络、系统等导致游戏无法正常运行的原因退换货。
													</li>
													<li>
														2.售出的激活码、账号、充值卡都仅适用于对应的正版游戏平台PC端，激活码和充值卡一旦激活即永久绑定在对应的正版游戏平台账户。所有steam类型账号都会提供初始邮箱及密码，可以支持玩家更改游戏密码及绑定手机令牌。
													</li>
													<li>
														3.所有游戏的配置要求请到正版游戏平台相关商店页面进行查看和参考，如若激活码在你的设备上无法正常运行和激活与本商城无关。
													</li>
													<li>
														4.所有steam账号质保时间为3个月，3个月内账号出现非人为导致的问题可进行售后。
													</li>
													<li>
														5.所有购买本商品的用户视为阅读并同意以上条款。
													</li>
												</>
											)}
										</ul>
									</div>
								</div>
							</>
						) : (
							<>
								<div className="minimum">
									<div className="title">
										<div className="left">最低配置要求</div>
									</div>

									<div className="content">
										<div className="left">
											<div>推荐</div>
											<div
												dangerouslySetInnerHTML={{
													__html: details.system_requirement?.recommend
														? details.system_requirement.recommend.replace(
																/<strong>(推荐配置|Recommended):<\/strong>/g,
																""
														  )
														: "<ul><br /><li>暂无数据</li></ul>",
												}}
											/>
										</div>

										<div className="right">
											<div>最低配置</div>
											<div
												dangerouslySetInnerHTML={{
													__html: details.system_requirement?.lowest
														? details.system_requirement.lowest.replace(
																/<strong>(最低配置|Minimum):<\/strong>/g,
																""
														  )
														: "<ul><br /><li>暂无数据</li></ul>",
												}}
											/>
										</div>
									</div>
								</div>

								<div className="introduce">
									<div className="title">
										<div className="left">游戏介绍</div>
									</div>

									<div className="content">
										<div>
											*本商品试玩号均为正式版，游戏内容完整。如游戏中包含在线功能，可在线联机，请放心试玩。
										</div>
										<div
											dangerouslySetInnerHTML={{ __html: details.description }}
										/>
									</div>
								</div>

								<div className="tips">
									<div className="title">
										<div className="left">购买须知</div>
									</div>

									<div className="content">
										<ul>
											<li>1. 购买的共享游戏每月不限游戏时长。</li>
											<li>
												2.
												使用共享游戏过程中，基于系统情况可能会为用户提供不同的共享账号，游戏的状态/进度/存档等会存在不一致；游戏高峰期也可能存在共享账号无空闲，用户暂时不能进行游戏的情况。
											</li>
											<li>
												3.
												因配置或网络问题导致的游戏异常无法进行，以及游戏官方进行维护导致无法游戏等情况，平台方已提供的共享服务无法撤回，平台方不接受任何形式的退换要求。
											</li>
											<li>
												4.
												如因用户违规行为导致的共享失效等情况，平台方已提供的共享服务不予退换，由用户承担全部损失。
											</li>
											<li>
												5.
												平台方向用户发送共享游戏后，由于用户本身问题导致账号被封禁等问题，平台方不承担责任，平台方无义务为用户重新提供共享游戏。
											</li>
											<li>
												6.
												特别说明：本平台开发的客户端程序与Steam官方之间不存在任何关联，特此声明！
											</li>
										</ul>
									</div>
								</div>
							</>
						)}
					</Skeleton>
				</div>

				<div className="recommend">
					<div className="title">
						<div className="left">
							<div></div>商城推荐
						</div>
					</div>

					<HotList list={recommendList} />
				</div>
				<GamePay
					details={{
						...details,
						payId,
						payName,
						payDesc,
						payPrice,
						payImg,
						gameType: typeList[0],
						from: isWjyz ? "wjyz" : null,
						buyCount,
					}}
					isShow={gameIsShow}
					onClose={gamePayClose}
				/>
			</div>
		</div>
	);
}
